import { useQuery } from "@tanstack/react-query";
import { AuthenticationResponse, UserApi } from "certiblok-api-manager";
import { instanceApi } from "../../../../../utils/hooks/api";
import { Ability } from "@casl/ability";

export async function openSyncFolder(redisKey: string, refreshRedisKey: string, abilityRules: any) {
	const { data: me } = await instanceApi(UserApi).getMe();
	const email = me?.email;
	const link = document.createElement("a");
	link.href = `${
		process.env.REACT_APP_ENV === "production" ? "certiblok-sync" : "certiblok-sync-staging"
	}://auth/callback?redisKey=${redisKey}&refreshRedisKey=${refreshRedisKey}&abilities=${JSON.stringify(
		abilityRules
	)}&email=${email}`;
	link.click();
	link.remove();
}

export async function authSSOUser(isSyncLogin: boolean) {
	const { data } = await instanceApi(UserApi).invalidCurrentAbilities();
	const { abilityRules, redisKey, refreshRedisKey } = data;

	const abilities = new Ability(abilityRules as any);

	const needRecover = abilities.can("manage", "Recovery");
	if (needRecover) {
		return data;
	}
	const needTwoFA = abilities.can("manage", "2FA");
	if (needTwoFA) {
		return data;
	}
	if (isSyncLogin) {
		openSyncFolder(redisKey, refreshRedisKey, abilityRules);
	}
	return data;
}

export function useAbilitiesLoader({
	isSyncLogin,
	onSuccess,
}: {
	isSyncLogin: boolean;
	onSuccess: (data: AuthenticationResponse) => void;
}) {
	return useQuery({
		queryKey: ["abilities-loader"],
		queryFn: async () => {
			const data = await authSSOUser(isSyncLogin);

			onSuccess(data);
		},
		retry: false,
	});
}
